import { AnchorProps } from "@twilio-paste/core/anchor";
import { ButtonProps } from "@twilio-paste/core/button";
import { Width } from "@twilio-paste/core/style-props";

import { ReactNode } from "react";

/**
 * Variants are based off of Paste examples
 * See: https://paste.twilio.design/patterns/empty-state/#examples-of-empty-state-use-cases
 */
export enum EmptyStateVariant {
  celebration = "celebration",
  create = "create",
  dependency = "dependency",
  noData = "noData",
  noResults = "noResults",
  oops = "oops",
  unauthorized = "unauthorized",
}

export enum EmptyStateActionType {
  button,
  anchor,
}

export interface EmptyStateActionProps {
  value: string;
}
export interface EmptyStateAnchorProps extends EmptyStateActionProps {
  props: AnchorProps;
}

export interface EmptyStateButtonProps extends EmptyStateActionProps {
  props: ButtonProps;
}

export enum EmptyStateOrientationOptions {
  horizontal = "horizontal",
  vertical = "vertical",
}

export interface EmptyStateProps {
  borderless?: boolean;
  description: string;
  heading?: string;
  imageWidth?: Width;
  maxWidth?: Width;
  orientation?: EmptyStateOrientationOptions;
  children?: ReactNode;
  variant: EmptyStateVariant;
}
